<template>
  <Listbox
    v-slot="{ isOpen }"
    :value="value"
    @input="$emit('input', $event)"
    class="ps-block ps-text-sm ps-leading-5 ps-font-medium ps-text-gray-700"
  >
    <ListboxButton
      class="ps-cursor-default ps-relative ps-w-full ps-rounded-md ps-border ps-border-solid ps-border-gray-300 ps-bg-white ps-pl-3 ps-pr-10 ps-py-2 ps-text-left focus:ps-outline-none focus:ps-shadow-outline-blue focus:ps-border-blue-300 ps-transition ps-ease-in-out ps-duration-150 sm:ps-text-sm sm:ps-leading-5"
    >
      <div class="ps-flex ps-items-center ps-space-x-3 ps-h-6">
        <template v-if="selected">
          <user-avatar
            v-if="userAvatar"
            class="ps-flex-shrink-0 ps-h-6 ps-w-6"
            color="ps-text-gray-300"
            :user="selected"
          />
          <span class="ps-block ps-truncate ps-text-gray-900">
            {{ selected.name }}
          </span>
        </template>
        <template v-else>
          <span class="block truncate opacity-50">{{ placeholder }}</span>
        </template>
      </div>
      <span
        class="ps-absolute ps-inset-y-0 ps-right-0 ps-flex ps-items-center ps-pr-2 ps-pointer-events-none"
      >
        <svg
          class="ps-h-5 ps-w-5 ps-text-gray-400"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
        >
          <path
            d="M7 7l3-3 3 3m0 6l-3 3-3-3"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </ListboxButton>
    <div
      v-show="isOpen"
      class="ps-z-40 ps-absolute ps-mt-1 ps-w-full ps-rounded-md ps-bg-white ps-shadow-lg"
    >
      <ListboxList
        class="ps-max-h-56 ps-rounded-md ps-py-1 ps-text-base ps-leading-6 ps-shadow-xs ps-overflow-auto focus:ps-outline-none sm:ps-text-sm sm:ps-leading-5"
      >
        <ListboxOption
          v-for="o in options"
          :value="o.id"
          :key="o.id"
          v-slot="{ isActive, isSelected }"
          class="ps-text-gray-900 ps-cursor-default ps-select-none "
        >
          <!--
          Select option, manage highlight styles based on mouseenter/mouseleave and keyboard navigation.

          Highlighted: "text-white bg-indigo-600", Not Highlighted: "text-gray-900"
        -->
          <div
            :class="isActive ? 'ps-bg-indigo-600' : ''"
            class="ps-relative ps-py-2 ps-pl-3 ps-pr-9"
          >
            <div class="ps-flex ps-items-center ps-space-x-3 ps-h-6">
              <user-avatar
                v-if="userAvatar"
                class="ps-flex-shrink-0 ps-h-6 ps-w-6"
                :user="o"
                :color="isActive ? 'ps-text-white' : 'ps-text-gray-300'"
              />
              <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
              <span
                :class="[
                  isActive ? 'ps-text-white' : 'ps-text-gray-900',
                  isSelected ? 'ps-font-semibold' : 'ps-font-normal'
                ]"
                class="ps-font-normal ps-block ps-truncate"
              >
                {{ o.name }}
              </span>
            </div>

            <!--
            Checkmark, only display for selected option.

            Highlighted: "text-white", Not Highlighted: "text-indigo-600"
          -->
            <span
              v-if="isSelected"
              :class="[isActive ? 'ps-text-white' : 'ps-text-indigo-600']"
              class="ps-absolute ps-inset-y-0 ps-right-0 ps-flex ps-items-center ps-pr-4"
            >
              <svg class="ps-h-5 ps-w-5" viewBox="0 0 20 20">
                <path
                  fill-rule="evenodd"
                  fill="currentColor"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          </div>
        </ListboxOption>
      </ListboxList>
    </div>
  </Listbox>
</template>

<script>
import {
  Listbox,
  ListboxLabel,
  ListboxButton,
  ListboxList,
  ListboxOption
} from '@tailwindui/vue'
import UserAvatar from '@/components/UserAvatar'

export default {
  props: {
    options: {
      type: Array,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    placeholder: {},
    userAvatar: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Listbox,
    ListboxLabel,
    ListboxButton,
    ListboxList,
    ListboxOption,
    UserAvatar
  },
  computed: {
    selected() {
      return this.options.find(o => o.id === this.value)
    }
  }
}
</script>
